import { css } from '@emotion/react';
import { zIndex } from 'shared/config';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '.definition-list': {
    '&__label--sticky': {
      top: 0,
      position: 'sticky',
      zIndex: zIndex.zStickyElements,
      backgroundColor: COLORS.WHITE,
    },
    '& > a': {
      overflowWrap: 'anywhere',
    },
    '&__label': {
      color: COLORS.NEUTRAL500,
    },
    '&__label > p': {
      marginBottom: 0,
    },
    '&__label--upper': {
      textTransform: 'uppercase',
    },
    '&__detail': {
      overflowWrap: 'break-word',
      marginInlineStart: 0,
      position: 'relative',
      marginBottom: theme.space[5],
    },
    '&__item--inline': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.space[3],
    },
    '&__label--inline': {
      textTransform: 'unset',
      display: 'flex',
      alignItems: 'center',
    },
    '&__label--inline:after': {
      content: '":"',
      marginRight: theme.space[2],
    },
    '&__detail--inline': {
      marginBottom: 0,
    },
    // only show separator when followed by another item
    '&__item--bottom-separator:has( + .definition-list__item):after': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '1px',
      backgroundColor: COLORS.NEUTRAL200,
      margin: `${theme.space[6]} 0`,
    },
  },
});
